import { ChangeEvent } from 'react';
import { FormField } from '../FormField';
import './currencyField.styles.css';
 
type CurrencyFieldProps = {
  label?: string;
  value: number;
  onChange?: (value: number) => void;
  error?: string;
  disabled?: boolean;
  decimals?: number;
  currencySymbol?: string;
};
 
export const CurrencyField = ({
  label,
  value,
  onChange,
  error,
  disabled,
  decimals = 2,
  currencySymbol = '$'
}: CurrencyFieldProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
	if (!onChange) return
	const numericValue = parseFloat(e.target.value);
	if (!isNaN(numericValue)) {
	  onChange(parseFloat(numericValue.toFixed(decimals)));
	}
  };
  return (
	<FormField label={label} error={error}>
	  <div className="currency-input">
		<span className="currency-symbol">{currencySymbol}</span>
		<input
		  type="number"
		  className="form-input-small"
		  value={value}
		  onChange={handleChange}
		  disabled={disabled}
		  step={10 ** -decimals}
		  min="0"
		  onFocus={(e) => e.target.select()}
		/>
	  </div>
	</FormField>
  );
};